export default __webpack_public_path__ + "static/ingress-a23fd19492b24d30e175f788099f69d7.svg";